import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { getParticipantCount } from '../../../base/participants/functions';
import { withPixelLineHeight } from '../../../base/styles/functions.web';
const useStyles = makeStyles()(theme => {
    return {
        badge: Object.assign(Object.assign({ backgroundColor: theme.palette.ui03, borderRadius: '100%', height: '16px', width: '16px', color: theme.palette.text01 }, withPixelLineHeight(theme.typography.labelBold)), { pointerEvents: 'none', position: 'absolute', right: '-3px', top: '-2px' })
    };
});
const ParticipantsCounter = () => {
    const { classes } = useStyles();
    const participantsCount = useSelector(getParticipantCount);
    return React.createElement("span", { className: classes.badge }, participantsCount);
};
export default ParticipantsCounter;
